import { useCallback } from 'react';
import { apiGet } from '../../lib/api';
import { SearchCombo } from './SearchCombo';

/** GRN fix #4 — searchable BOQ line combo (server search on description / item code, 20 per page). */
export function BOQSearchSelect({ projectId, value, onSelect, testid = 'boq-search', compact = true, disabled = false }) {
  const fetchPage = useCallback((q, page) => {
    if (!projectId) return Promise.resolve({ items: [], total: 0 });
    return apiGet('/boq/search', { project_id: projectId, q: q || undefined, page, limit: 20 });
  }, [projectId]);
  return (
    <SearchCombo
      value={value} displayLabel={value ? `${value.item_code ? `${value.item_code} · ` : ''}${(value.description || '').slice(0, 60)}` : ''}
      onSelect={onSelect} fetchPage={fetchPage} getKey={(r) => r.id} testid={testid} compact={compact} disabled={disabled || !projectId}
      placeholder={projectId ? 'Petty / non-BOQ — or search BOQ item…' : 'Select a project first'}
      emptyText={(q) => (q ? `No BOQ item matches '${q}'` : 'No BOQ items in this project')}
      renderRow={(r) => (
        <div><span className="font-mono text-slate-500">{r.item_code}</span> {(r.description || '').slice(0, 80)}<span className="text-slate-400"> · {r.unit}</span></div>
      )}
    />
  );
}

/** Searchable project combo (client-side filter over the already-loaded list). */
export function ProjectSearchSelect({ projects = [], value, onSelect, testid = 'project-search', disabled = false }) {
  const fetchPage = useCallback(async (q, page) => {
    const t = (q || '').toLowerCase();
    const rows = projects.filter(p => !t || `${p.name} ${p.site_code || ''} ${p.client_name || ''}`.toLowerCase().includes(t));
    return { items: rows.slice(0, page * 20), total: rows.length };
  }, [projects]);
  const sel = projects.find(p => p.id === value) || null;
  return (
    <SearchCombo
      value={sel} displayLabel={sel?.name || ''} onSelect={(p) => onSelect(p?.id || '', p)} fetchPage={fetchPage}
      getKey={(p) => p.id} testid={testid} disabled={disabled} placeholder="Search project…"
      emptyText={(q) => (q ? `No project matches '${q}'` : 'No projects')}
      renderRow={(p) => <div>{p.name}{p.site_code ? <span className="text-slate-400"> · {p.site_code}</span> : null}</div>}
    />
  );
}
